import { BP42Action } from '@r1-frontend/bp42/constants/actions';

import { IAction } from '@r1-frontend/shared/types/Redux';

const startedTyping = (): IAction<BP42Action.StartedTyping, null> => ({
    type: BP42Action.StartedTyping,
    payload: null,
});

export default startedTyping;
